import React from "react";

interface Step {
  number: number;
  label: string;
}

interface StepIndicatorProps {
  currentStep: number;
  steps: Step[];
}

const CheckIcon: React.FC = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M3.5 8L6.5 11L12.5 5"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const StepIndicator: React.FC<StepIndicatorProps> = ({ currentStep, steps }) => {
  return (
    <div className="flex-shrink-0 px-4 sm:px-6 lg:px-8 pb-4">
      <div className="flex items-center">
        {steps.map((step, index) => {
          const isCompleted = currentStep > step.number;
          const isActive = currentStep === step.number;

          return (
            <React.Fragment key={step.number}>
              {/* Step node: circle + label inline */}
              <div className="flex items-center gap-2 flex-shrink-0">
                <div
                  className={`w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 transition-colors ${
                    isCompleted
                      ? "bg-[#0DB5B5]"
                      : isActive
                      ? "bg-[#1F1F1F]"
                      : "bg-white border border-[#D1D5DB]"
                  }`}
                >
                  {isCompleted ? (
                    <CheckIcon />
                  ) : (
                    <span
                      className={`text-[10px] 3xl:text-xs font-medium font-inter leading-none ${
                        isActive ? "text-white" : "text-[#9CA3AF]"
                      }`}
                    >
                      {step.number}
                    </span>
                  )}
                </div>
                <span
                  className={`text-xs 3xl:text-sm font-inter whitespace-nowrap ${
                    isCompleted
                      ? "text-[#0DB5B5] font-medium"
                      : isActive
                      ? "text-[#1F1F1F] font-medium"
                      : "text-[#9CA3AF]"
                  }`}
                >
                  {step.label}
                </span>
              </div>

              {/* Connector dashed line */}
              {index < steps.length - 1 && (
                <div className="flex-1 mx-3">
                  <div
                    className="w-full border-t-2 border-dashed"
                    style={{
                      borderColor: currentStep > step.number ? "#0DB5B5" : "#D1D5DB",
                    }}
                  />
                </div>
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default StepIndicator;
